import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Button, Dropdown, Modal } from "react-bootstrap";
import { copyCandidatesToJob } from "../actions";

export class CopyCandidateToJob extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      jobId: null,
      validJob: null,
      showConfirm: false,
    };
  }

  handleChangeAction = () => {
    this.props.changeAction(false, false);
  };

  handleJobChoice = (e) => {
    this.setState({ jobId: e, validJob: null });
  };

  handleCopyButton = () => {
    if (!this.state.jobId) {
      this.setState({ validJob: "error" });
    } else {
      this.setState({ showConfirm: true });
    }
  };

  handleConfirm = () => {
    this.props.onCopyCandidateToJob(
      this.props.candidateIds,
      this.state.jobId,
      this.props.jobId
    );
    this.props.changeAction(false, true);
  };

  handleCancel = () => {
    this.setState({ showConfirm: false });
  };

  render() {
    const { jobs } = this.props;

    let JobsDropdownOptions = [];

    const multipleCandidates = this.props.candidateIds.length > 1;

    if (
      jobs !== undefined &&
      jobs.filter((job) => job.get("jobStatus") > 0).size > 0
    ) {
      const sortedJobs = jobs.sort((a, b) =>
        a.get("jobTitle").localeCompare(b.get("jobTitle"))
      );
      JobsDropdownOptions = sortedJobs
        .filter(
          (job) =>
            job.get("jobStatus") === 2 &&
            String(job.get("jobDetailId")) !== this.props.jobId &&
            job.get("createdBy") !== 0
        )
        .entrySeq()
        .map((job) => (
          <Dropdown.Item
            eventKey={job[0]}
            key={job[0]}
            style={{
              margin: "10px 0px",
              fontSize: "16px",
              width: "300px",
            }}
          >
            <div
              className="jobSelector-job"
              style={{
                display: "block",
                whiteSpace: "nowrap",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {job[1].get("jobTitle")}
            </div>
            <div className="jobSelector-location">
              {job[1].get("city") || job[1].get("state")}
              {job[1].get("city") && job[1].get("state")
                ? `, ${job[1].get("state")}`
                : `${job[1].get("country") ? ", " : ""}${job[1].get(
                    "country"
                  )}`}
              {job[1].get("city") ||
              job[1].get("state") ||
              job[1].get("country")
                ? " - "
                : ""}{" "}
              {job[1].get("jobCode")}
            </div>
          </Dropdown.Item>
        ));
    }

    return (
      <div>
        <Modal.Header>
          {this.state.showConfirm ? (
            <h4>
              Are you sure you want to copy{" "}
              {multipleCandidates ? "these candidates" : "this candidate"}?
            </h4>
          ) : (
            <h4>Copy Candidate{multipleCandidates && "s"} to Different Job</h4>
          )}
        </Modal.Header>
        <Modal.Body>
          {this.state.showConfirm ? (
            <p>
              Once copied, the candidate{multipleCandidates && "s"} will be
              visible in the{" "}
              <span style={{ fontWeight: "bold" }}>Incoming</span> stage of the
              job you select. If you copy the candidate
              {multipleCandidates && "s"} to a different pipeline stage, any
              automated actions associated with that job will apply.
            </p>
          ) : (
            <div>
              <p>
                Select a job below to copy the selected candidate
                {multipleCandidates && "s"} to. The candidate
                {multipleCandidates && "s"} will be visible in the{" "}
                <span style={{ fontWeight: "bold" }}>Incoming</span> stage of
                the job you select. Only test results that are of the same
                assessment in the destination position should be copied over.
              </p>
              <Dropdown onSelect={this.handleJobChoice} id="jobsDropdown">
                <Dropdown.Toggle variant="outline-secondary">
                  {this.state.jobId
                    ? jobs.get(this.state.jobId).get("jobTitle")
                    : "Select a job"}
                </Dropdown.Toggle>
                <Dropdown.Menu
                  style={{ maxHeight: "300px", overflowY: "scroll" }}
                >
                  {JobsDropdownOptions}
                </Dropdown.Menu>
              </Dropdown>
              {this.state.validJob !== null ? (
                <p className="manual-override-invalid-feedback">
                  Please choose a job.
                </p>
              ) : null}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={
              this.state.showConfirm
                ? this.handleCancel
                : this.handleChangeAction
            }
            id="cancelCopyCandidateToJob"
            variant="outline-primary"
            className="btn-cancel"
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={
              this.state.showConfirm
                ? this.handleConfirm
                : this.handleCopyButton
            }
            id="confirmCopyCandidateToJob"
          >
            Copy
          </Button>
        </Modal.Footer>
      </div>
    );
  }
}

CopyCandidateToJob.propTypes = {
  changeAction: PropTypes.func,
  candidateIds: PropTypes.array,
  jobId: PropTypes.string,
  jobs: PropTypes.object,
  onCopyCandidateToJob: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => ({
  onCopyCandidateToJob: (candidateIds, jobId, currentJobDetailId) =>
    dispatch(copyCandidatesToJob(candidateIds, jobId, currentJobDetailId)),
});

export default connect(undefined, mapDispatchToProps)(CopyCandidateToJob);
